var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "14px",
    viewBox: "0 0 11 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-54.000000, -216.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.000000, 216.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0,
    x: 0,
    y: 0,
    width: 11,
    height: 13.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85576699,0.227071381 L5.85576699,4.31785085 L10.8107739,4.31785085 L10.8107739,11.3796965 C10.8107739,11.8187488 10.6552744,12.1957712 10.3442755,12.5055805 C10.0330216,12.8171742 9.65769863,12.9729286 9.2175417,12.9729286 L1.7824583,12.9729286 C1.34298114,12.9729286 0.967318249,12.8171742 0.656064415,12.5055805 C0.344810581,12.1957712 0.189226146,11.8187488 0.189226146,11.3796965 L0.189226146,1.82030354 C0.189226146,1.38125124 0.344810581,1.0060132 0.656064415,0.694419483 C0.967318249,0.382825768 1.34298114,0.227071381 1.7824583,0.227071381 L5.85576699,0.227071381 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.215655 3.21417514 7 0.227071381 7 3.21417514"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileActive);
export default __webpack_public_path__ + "static/media/fileActive.ce5f212bc7b21e65701e514f1a288532.svg";
export { ForwardRef as ReactComponent };